<template>
	<div class="sheet bg-neutral-100">
		<div
			class="sheet__header simulator__grid simulator__grid--1-2 colorCtx-dark"
		>
			<div class="sheet__stepNameAndNum">
				<div class="sheet__stepNum">
					{{ stepNum }}
				</div>

				<div class="sheet__stepName">
					{{ stepName }}
				</div>
			</div>

			<div class="sheet__headerContent">
				<slot name="headerBody"></slot>
			</div>
		</div>

		<div class="sheet__content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		stepNum: {
			type: [String, Number],
			required: true,
		},
		stepName: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="scss">
.sheet {
	--size-num: 50px;

	--padding-left-sheet-content-desktop: 120px;
	--padding-block-sheet-content: 40px;
	--padding-left-sheet-content: var(--padding-left-sheet-content-desktop);
	--padding-right-sheet-content: 40px;

	--padding-left-sheet-header: 30px;
	--padding-right-sheet-header: 30px;

	--padding-inline-additional-fields-card: 16px;

	border-radius: 16px;
	overflow: hidden;
}

.sheet__header {
	background-color: var(--color-primary-600);
	color: #fff;
	min-height: var(--size-num);
	padding-block: 20px;
	box-sizing: content-box;
	display: flex;
	align-items: flex-start;
	padding-right: var(--padding-right-sheet-header);
	padding-left: var(--padding-left-sheet-content);
}

.sheet__stepNameAndNum {
	display: flex;
	align-items: center;
}

.sheet__headerContent {
	flex-grow: 1;
	padding-top: 0.65rem;

	&:empty {
		display: none;
	}
}

.sheet__stepNameAndNum {
	margin-left: calc(
		-1 * var(--padding-left-sheet-content) + var(--padding-left-sheet-header)
	);
}

.sheet__stepNum {
	--size: var(--size-num);
	flex-shrink: 0;
	border-radius: 50%;
	width: var(--size);
	height: var(--size);
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: var(--color-neutral-0);
	color: var(--color-primary-600);
	margin-right: calc(
		var(--padding-left-sheet-content-desktop) - var(--padding-left-sheet-header) -
			var(--size-num)
	);
}

.sheet__stepName {
	font-size: var(--font-size-l);
	font-weight: var(--font-weight-bold);
	line-height: 24px;
}

.sheet__content {
	padding-block: var(--padding-block-sheet-content);
	padding-left: var(--padding-left-sheet-content);
	padding-right: var(--padding-right-sheet-content);
}

.sheet__detailsTitle {
	font-size: var(--font-size-l);
	color: var(--color-neutral-900);
	font-weight: var(--font-weight-bold);
	line-height: 24px;
}

.sheet__detailsDesc {
	font-size: var(--font-size-m);
	color: var(--color-neutral-600);
	line-height: 16px;
}

.sheet__subtitle {
	font-size: var(--font-size-l);
	color: var(--color-primary-600);
	font-weight: var(--font-weight-bold);
	line-height: 24px;
}

.sheet__details {
	font-size: var(--font-size-m);
	color: var(--color-primary-600);
	line-height: 16px;
}

.sheet__controlTitle {
	color: var(--color-neutral-600);
	font-size: var(--font-size-l);
	line-height: 24px;
}

.colorCtx-dark {
	.sheet__controlTitle {
		font-weight: var(--font-weight-light);
		color: var(--color-primary-50);
	}
}

.sheet__divider {
	background-color: var(--color-neutral-175);
	height: 1px;
	margin-block: 40px;
	margin-right: calc(-1 * var(--padding-right-sheet-content));
}
.sheet__footer {
	display: flex;
	justify-content: flex-end;
	gap: 20px;
	margin-top: 60px;
}

.bulkSpanOperations {
	padding: 20px 32px 37px;
	background-color: var(--color-neutral-125);
	margin-right: calc(-1 * var(--padding-right-sheet-content));
	display: grid;
	grid-template-columns: 177px 173px 1fr;
	gap: 20px;
	align-items: flex-end;
	padding: 20px 32px 37px;
	background-color: var(--color-neutral-125);
	margin-right: calc(-1 * var(--padding-right-sheet-content));
}

.bulkSpanOperations__actions {
	display: flex;
	gap: 20px;
}

.spansTable__row {
	margin-right: calc(-1 * var(--padding-sheet));
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(min(300px, 100%), 1fr));

	&:not(:last-child) {
		border-bottom: 1px solid var(--color-neutral-125);
		padding-bottom: 0.5rem;
		margin-bottom: 0.5rem;
	}

	&--hasGap {
		gap: 10px 20px;
	}
}

.spansTable__item {
	display: flex;
	align-items: center;
	white-space: nowrap;
	padding: 5px 5px 5px 30px;
	background-color: var(--color-neutral-100);
	width: 100%;
}

.spansTable__dragHandle {
	cursor: grab;
	opacity: 0;
	visibility: hidden;
	position: absolute;
	margin-left: -22px;
}

.spansTable__checkboxCell {
	display: flex;
	align-items: center;
	margin-right: 16px;
}

.spansTable__item:not(.is-checkable) {
	.spansTable__checkboxCell .b-checkbox__checkbox {
		opacity: 0;
		visibility: hidden;
	}
}

.spansTable__deleteSpanBtn {
	margin-left: 4px;
	opacity: 0;
	visibility: hidden;
}

.spansTable__item {
	&:hover {
		&.is-draggable {
			background-color: var(--color-neutral-125);
			.spansTable__dragHandle {
				opacity: 1;
				visibility: visible;
			}
		}

		&.is-deletable .spansTable__deleteSpanBtn {
			opacity: 1;
			visibility: visible;
		}
	}

	&.is-ghost {
		background-color: var(--color-neutral-150);
	}
}

.spansTable__field {
	flex-grow: 0;
	flex-shrink: 0;
	width: 120px;
	margin-left: auto;
}

.spansTable__smallText {
	font-size: var(--font-size-s);
	color: var(--color-neutral-500);
}

.spansTable__label {
	color: var(--color-neutral-600);
	font-size: var(--font-size-m);
}

.spansTable__checkboxCell {
	display: flex;
	align-items: center;
	gap: 20px;
}

.spansTable__headCell2 {
	padding-left: 16px;
}

.spansTable__spanNumber {
	font-variant-numeric: tabular-nums;
}

.additionalFieldsCard {
	border-radius: 8px;
	padding: 16px var(--padding-inline-additional-fields-card) 60px;
	background: var(--color-neutral-125);
	overflow: hidden;

	&.is-large {
		margin-inline: calc(-1 * var(--padding-inline-additional-fields-card));

		.additionalFieldsCard__constrained {
			margin-inline: var(--padding-inline-additional-fields-card);
		}
	}

	.spansTable__row {
		&:not(:last-child) {
			border-bottom: 1px solid var(--color-neutral-150);
		}
	}
}

.additionalFieldsCard .spanMappedValuesEditor__bulkControls {
	background: var(--color-neutral-150);
}

.sheet__image {
	display: block;
	max-width: 100%;
	width: 248px;
	height: auto;
	margin-bottom: 2rem;
}

@media (max-width: 1100px) {
	.sheet {
		--padding-right-sheet-content: 20px;
		--padding-inline-additional-fields-card: var(--padding-right-sheet-content);
		--padding-left-sheet-content: var(--padding-right-sheet-content);
		--padding-right-sheet-header: var(--padding-right-sheet-content);
	}

	.additionalFieldsCard {
		border-radius: 0;
		margin-inline: calc(-1 * var(--padding-inline-additional-fields-card));
	}

	.additionalFieldsCard.is-large .additionalFieldsCard__constrained {
		margin-inline: 0;
	}
}

@media (max-width: 768px) {
	.sheet__footer {
		flex-direction: column-reverse;
	}

	.bulkSpanOperations {
		grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
		margin-left: calc(-1 * var(--padding-left-sheet-content));
	}

	.bulkSpanOperations__actions {
		grid-column: span 2;
	}

	.bulkSpanOperations--edit {
		.bulkSpanOperations__actions {
			& > :first-child {
				margin-left: auto;
			}
		}
	}

	.bulkSpanOperations--create {
		.bulkSpanOperations__actions {
			& > :first-child {
				width: 100%;
			}
		}
	}

	.sheet__image {
		margin: auto;
	}
}
</style>
